module.exports = __webpack_public_path__ + "static/media/Setlocation.d9a69542.png";